import { cva } from 'class-variance-authority';

import { mergeClasses } from '@/utils';

export const CHECKBOX_VARIANTS = cva(
  mergeClasses(
    'peer shrink-0 rounded-xxs border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 bg-neutral-0 border-neutral-4 dark:bg-neutral-10 dark:border-neutral-8',
    // Selected
    'data-[state=checked]:!bg-primary-base data-[state=checked]:text-white data-[state=checked]:border-primary-base',
    // indeterminate
    'data-[state=indeterminate]:bg-primary-base data-[state=indeterminate]:text-white data-[state=indeterminate]:border-primary-base',
  ),
  {
    variants: {
      size: {
        default: 'size-4',
        lg: 'size-5',
      },
      error: {
        true: 'bg-neutral-0 border-semantic-error-base dark:bg-neutral-10 dark:border-semantic-error-base',
      },
      disabled: {
        true: mergeClasses(
          // Disabled
          'cursor-not-allowed !bg-neutral-2 !border-neutral-4 dark:!bg-neutral-9 dark:!border-neutral-8',
          // Disabled + Selected
          'data-[state=checked]:bg-neutral-2 data-[state=checked]:border-neutral-4 data-[state=checked]:text-neutral-6 dark:data-[state=checked]:bg-neutral-9 dark:data-[state=checked]:border-neutral-8 dark:data-[state=checked]:text-neutral-7',
        ),
      },
    },
    defaultVariants: {
      size: 'default',
      error: false,
      disabled: false,
    },
  },
);

export const LABEL_VARIANTS = cva('!font-medium cursor-pointer', {
  variants: {
    size: {
      default: '!text-body-sm',
      lg: '!text-body-base',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const ICON_VARIANTS = cva('data-[state=checked]:text-white', {
  variants: {
    size: {
      default: 'size-3',
      lg: 'size-3.5',
    },
    disabled: { true: 'text-neutral-6' },
  },
  defaultVariants: {
    size: 'default',
    disabled: false,
  },
});
